import { render } from "./TheHeader.vue?vue&type=template&id=d2609bda&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=d2609bda&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d2609bda"

export default script